export default __webpack_public_path__ + "1c58990c05da68ae3d6800fe4de9739e.ttf";